import { useField, useFormikContext } from 'formik';
import { makeStyles } from 'tss-react/mui';
import { TimePicker } from '@mui/x-date-pickers';
import { momentParse } from '../../utils/time';

const useStyles = makeStyles()(theme => ({
  field: {
    margin: theme.spacing(1, 0),
  }
}));

type Props = {
  name: string;
  label?: string;
  disabled?: boolean;
  touched?: boolean;
  className?: string;
  helperText?: React.ReactNode;
};

const TimeField = (props: Props) => {
  const {
    name,
    label,
    className,
    disabled,
    touched: formTouched,
    helperText,
  } = props;
  const { classes, cx } = useStyles();
  const [field, meta] = useField(name);
  const { setFieldValue, setFieldTouched } = useFormikContext();

  const touched = formTouched || meta.touched;
  const currentError = meta.error;
  const parsedValue = momentParse(field.value);

  return (
    <TimePicker
      value={parsedValue}
      label={label}
      disabled={disabled}
      onChange={(date) => {
        setFieldValue(name, date, true);
        setFieldTouched(name, true);
      }}
      onClose={() => {
        setFieldTouched(name, true);
      }}
      className={cx(classes.field, className)}
      slotProps={{
        textField: {
          name,
          onBlur: field.onBlur,
          variant: 'outlined',
          error: touched && Boolean(currentError),
          helperText: (touched && currentError) || helperText,
        },
      }}
    />
  );
};

export default TimeField;
